import { motion } from 'motion/react';

interface ZoomInEntryProps {
  children: React.ReactNode;
  threshold?: number;
  delay?: number;
}

export function ZoomInEntry({ children, threshold = 0.3, delay = 1.7 }: ZoomInEntryProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: threshold }}
      transition={{ duration: 1.2, delay }}
    >
      <motion.div
        initial={{ scale: 1.14 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true, amount: threshold }}
        transition={{ duration: 1.2, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
}
